import { createSlice } from '@reduxjs/toolkit'
import { studiesTexts } from 'locale/es'
import StudyService from 'services/StudyService'
import { toast } from './notificationReducer'

const initialState = { data: null, loading: false, error: null }

const studySlice = createSlice({
  name: 'study',
  initialState,
  reducers: {
    setStudy(state, action) {
      const { data } = action.payload

      const forms = data.formsSummary.map(form => {
        return {
          value: form.id,
          name: form.form_translations[0]?.title,
          slug: form.slug,
          description: form.form_translations[0]?.description
        }
      })

      const reducerData = {
        id: data.studyData.id,
        title: data.studyData.translations[0]?.study_title,
        forms
      }

      return { ...state, data: reducerData, loading: false, error: null }
    },
    setStudyLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setStudyError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetStudyState(state, action) {
      return initialState
    }
  },
})

export const { setStudy, setStudyLoading, setStudyError, resetStudyState } =
  studySlice.actions

export const initializeStudy = (studyId) => {
  return async (dispatch) => {
    try {
      dispatch(setStudyLoading());

      const { data: studyData } = await StudyService.get(studyId) // ! The only useful info from this call is the study title
      const { data: formsSummary } = await StudyService.getFormsSummary(studyId)

      const dataToDispatch = {
        studyData: studyData.data,
        formsSummary: formsSummary.data.items
      }

      dispatch(setStudy({ data: dataToDispatch }))
    }
    catch (error) {
      console.error(error)
      dispatch(setStudyError({ message: error.message, status: error.response?.status }));
      dispatch(toast(studiesTexts.STUDY_LOADING_ERROR, 'error'))
    }
  }
}

export default studySlice.reducer
